import { useStaticQuery, graphql } from "gatsby"

const default_lang_prefix = process.env.GATSBY_DEFAULT_LANG_PREFIX || ""
const replace_default_lang_prefix =
  process.env.GATSBY_REPLACE_TO_DEFAULT_LANG_PREFIX || ""
const SITE_ROOT = process.env.GATSBY_SITE_ROOT || ""

const removeSiteRoot = (path) => {
  if (path && SITE_ROOT && path.includes(`${SITE_ROOT}/`)) {
    return path.replace(`${SITE_ROOT}/`, "")
  }
  return path
}

// Neue Funktion zum Entfernen des Sprach-Präfixes
const removeLanguagePrefix = (path) => {
  if (path && replace_default_lang_prefix) {
    // Entfernt das Präfix am Anfang des Pfads
    const prefixWithSlash = `${replace_default_lang_prefix}/`
    if (path.startsWith(prefixWithSlash)) {
      return path.substring(prefixWithSlash.length)
    }
    // Falls der Pfad genau dem Präfix entspricht
    if (path === replace_default_lang_prefix) {
      return ""
    }
  }
  return path
}

// Hilfsfunktion, die beide Bereinigungen kombiniert
const cleanPath = (path) => {
  let cleaned = removeSiteRoot(path)
  //cleaned = removeLanguagePrefix(cleaned)
  return cleaned
}

export const useLinkData = (to, language) => {
  const { allStoryblokEntry, allStoryblokLink, allStoryblokTag } =
    useStaticQuery(graphql`
      query SeoLinkQuery {
        allStoryblokEntry {
          nodes {
            full_slug
            internalId
            field_seoURL_string
            lang
            uuid
          }
        }
        allStoryblokLink {
          nodes {
            real_path
            slug
            uuid
            alternates {
              lang
              path
            }
          }
        }
        allStoryblokTag {
          nodes {
            name
            taggings_count
          }
        }
      }
    `)
  let newSeoLinks = []
  const entries = allStoryblokEntry.nodes
  const links = allStoryblokLink.nodes
  const tags = allStoryblokTag.nodes
  const defaultLang = process.env.GATSBY_DEFAULT_LANG
    ? process.env.GATSBY_DEFAULT_LANG
    : "de"

  if (!entries || !links || !to || !language) {
    return newSeoLinks
  }

  language = language === defaultLang ? "default" : language
  links
    .filter((link) => {
      const toClean = to.replace(/^\//, "").replace(/\/$/, "")
      return (
        to.includes(link.slug) ||
        link.slug.includes(to) ||
        to.includes(link.uuid) ||
        link.uuid.includes(to) ||
        (link.alternates &&
          link.alternates.some((alt) => {
            const altFullPath = alt.lang + "/" + alt.path
            // Also match when `to` uses a different lang prefix but the same
            // slug (e.g. /en/de-slug authored incorrectly in Storyblok content)
            const toWithoutLangPrefix = toClean.replace(/^[a-z]{2}\//, "")
            return (
              toClean === altFullPath ||
              altFullPath === toClean ||
              (alt.path && alt.path !== "" && toWithoutLangPrefix === alt.path)
            )
          }))
      )
    })
    .forEach((linkEntry, index) => {
      let seoLinkElement = entries.find(
        (link) => linkEntry.uuid === link.uuid && link.lang === language
      )
      let link = linkEntry.slug === "home" ? "/" : linkEntry.slug
      if (seoLinkElement) {
        link = cleanPath(seoLinkElement.field_seoURL_string)
          ? cleanPath(seoLinkElement.field_seoURL_string)
          : link
      }
      if (default_lang_prefix !== null && default_lang_prefix !== "") {
        newSeoLinks[linkEntry.slug] = cleanPath(
          default_lang_prefix + "/" + link
        )
        newSeoLinks[linkEntry.uuid] = cleanPath(
          default_lang_prefix + "/" + link
        )
      } else {
        newSeoLinks[linkEntry.slug] = cleanPath(link)
        newSeoLinks[linkEntry.uuid] = cleanPath(link)
      }

      if (language !== "default" && linkEntry.alternates !== null) {
        let altLink = linkEntry.alternates.find(
          (linkElement) => linkElement.lang === language
        )
        if (typeof altLink !== "undefined") {
          seoLinkElement = entries.find(
            (link) => linkEntry.uuid === link.uuid && link.lang === altLink.lang
          )

          link =
            altLink.path === "home"
              ? altLink.lang + "/"
              : altLink.lang + "/" + altLink.path
          if (seoLinkElement) {
            const seoUrl = cleanPath(seoLinkElement.field_seoURL_string)
            // Only override with seoURL if it belongs to the correct language
            if (seoUrl && seoUrl.startsWith(altLink.lang + "/")) {
              link = seoUrl
            }
          }
          if (!link.startsWith(altLink.lang)) {
            link = altLink.lang + "/" + link
          }
          newSeoLinks[altLink.lang + "/" + linkEntry.slug] = cleanPath(link)
          newSeoLinks[altLink.lang + "/" + linkEntry.uuid] = cleanPath(link)
        } else {
          // No language-specific alternate found — fall back to any available
          // alternate path (e.g. EN) so that languages sharing the same URL
          // structure don't regress to the default-language slug.
          const fallbackAlt = linkEntry.alternates.find(
            (linkElement) => linkElement.path && linkElement.path !== ""
          )
          if (fallbackAlt) {
            link = language + "/" + fallbackAlt.path
          }
        }
        newSeoLinks[linkEntry.slug] = cleanPath(link)
        newSeoLinks[linkEntry.uuid] = cleanPath(link)
      }
      // Add lookup keys for each alternate path so links authored with a
      // translated URL (e.g. /de/...) resolve to the correct page.
      // Also index default_lang_prefix/alt.path so that links authored with
      // the wrong language prefix (e.g. /en/de-slug) resolve correctly.
      ;(linkEntry.alternates || []).forEach((alt) => {
        const altKey = alt.lang + "/" + alt.path
        newSeoLinks[altKey] = cleanPath(link)
        newSeoLinks[altKey + "/"] = cleanPath(link)
        if (default_lang_prefix && default_lang_prefix !== "" && alt.path) {
          newSeoLinks[default_lang_prefix + "/" + alt.path] = cleanPath(link)
          newSeoLinks[default_lang_prefix + "/" + alt.path + "/"] =
            cleanPath(link)
        }
      })
    })

  tags
    .filter((tag) => {
      return to.includes(tag.name) || tag.name.includes(to)
    })
    .forEach((tag, i) => {
      if (language === "default") {
        newSeoLinks[tag.name] = "tags/" + tag.name.toLowerCase()
        newSeoLinks["tags/" + tag.name] = "tags/" + tag.name.toLowerCase()
      } else {
        newSeoLinks[tag.name] = language + "/tags/" + tag.name.toLowerCase()
        newSeoLinks[language + "/tags/" + tag.name] =
          language + "/tags/" + tag.name.toLowerCase()
        newSeoLinks["tags/" + tag.name] =
          language + "/tags/" + tag.name.toLowerCase()
      }
    })

  return newSeoLinks
}
